<template>
  <table class="m-table AppointmentForm">
    <tbody>
      <tr>
        <th colspan="2">状態</th>
        <td colspan="8"><multiselect v-model="watch.state" :options="state" label="name" :searchable="false" :show-labels="false" placeholder="状態"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">名前</th>
        <td colspan="4"><input type='text' v-model="appointment.f_name" placeholder="姓" @keypress.self.prevent.13></td>
        <td colspan="6"><input type='text' v-model="appointment.l_name" placeholder="名" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">かな</th>
        <td colspan="4"><input type='text' v-model="appointment.f_name_kana" placeholder="せい" @keypress.self.prevent.13></td>
        <td colspan="6"><input type='text' v-model="appointment.l_name_kana" placeholder="めい" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">サブ名前</th>
        <td colspan="4"><input type="text" v-model="appointment.sub_f_name" placeholder="サブ:姓" @keypress.self.prevent.13></td>
        <td colspan="6"><input type="text" v-model="appointment.sub_l_name" placeholder="サブ:名" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">サブかな</th>
        <td colspan="4"><input type="text" v-model="appointment.sub_f_name_kana" placeholder="サブ:せい" @keypress.self.prevent.13></td>
        <td colspan="6"><input type="text" v-model="appointment.sub_l_name_kana" placeholder="サブ:めい" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">郵便番号 | 都道府県</th>
        <td colspan="4"><input type='text' v-model="appointment.zip" placeholder="郵便番号" @keyup="getYubin" @keypress.self.prevent.13></td>
        <td colspan="6"><multiselect v-model="watch.pref" :options="prefs" label="name" :searchable="true" :show-labels="false" placeholder="都道府県"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2" class="req">住所</th>
        <td colspan="4"><input type='text' v-model="appointment.address1" placeholder="市区町村・番地" @keypress.self.prevent.13></td>
        <td colspan="6"><input type='text' v-model="appointment.address2" placeholder="建物名・部屋番号" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">携帯TEL | 固定TEL</th>
        <td colspan="4"><input type='text' maxlength="11" minlength="10" v-model="appointment.tel1" placeholder="携帯TEL" @keypress.self.prevent.13></td>
        <td colspan="6"><input type='text' maxlength="11" minlength="10" v-model="appointment.tel2" placeholder="固定TEL" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">前日確認TEL連絡先 | 時間帯</th>
        <td colspan="4"><multiselect v-model="watch.preferred_contact" :options="preferred_contact" label="name" :searchable="true" :show-labels="false" placeholder="前日確認TEL連絡先"></multiselect></td>
        <td colspan="6"><input type='text' v-model="appointment.contact_timezone" placeholder="時間帯" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">FAX | MAIL</th>
        <td colspan="4"><input type='text' v-model="appointment.fax" placeholder="FAX" @keypress.self.prevent.13></td>
        <td colspan="6"><input type='text' v-model="appointment.mail" placeholder="MAIL" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">問合わせ日</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="appointment.contact_date" placeholder="問合わせ日" @keypress.self.prevent.13></td>
        <th colspan="2" class="req">問合わせ方法(家庭→弊社)</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="contact_method_0">未選択</label>
            <input type="radio" name="contact_method" required id="contact_method_0" value="0" v-model="appointment.contact_method" @keypress.self.prevent.13>
            <label for="contact_method_1">TEL</label>
            <input type="radio" name="contact_method" id="contact_method_1" value="1" v-model="appointment.contact_method" @keypress.self.prevent.13>
            <label for="contact_method_2">MAIL</label>
            <input type="radio" name="contact_method" id="contact_method_2" value="2" v-model="appointment.contact_method" @keypress.self.prevent.13>
            <label for="contact_method_3">その他</label>
            <input type="radio" name="contact_method" id="contact_method_3" value="3" v-model="appointment.contact_method" @keypress.self.prevent.13>
          </div>
        </td>
      </tr>
      <tr>
        <th colspan="2" class="req">媒体</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="mi">未選択</label>
            <input type="checkbox" id="mi" value="0" v-model="appointment.mediumArray" @keypress.self.prevent.13>
            <label for="dm">DM</label>
            <input type="checkbox" id="dm" value="1" v-model="appointment.mediumArray" @keypress.self.prevent.13>
            <label for="hg">貼紙</label>
            <input type="checkbox" id="hg" value="2" v-model="appointment.mediumArray" @keypress.self.prevent.13>
            <label for="hp">HP</label>
            <input type="checkbox" id="hp" value="3" v-model="appointment.mediumArray" @keypress.self.prevent.13>
            <label for="shokai">紹介</label>
            <input type="checkbox" id="shokai" value="4" v-model="appointment.mediumArray" @keypress.self.prevent.13>
            <label for="telchu">TEL注</label>
            <input type="checkbox" id="telchu" value="5" v-model="appointment.mediumArray" @keypress.self.prevent.13>
            <label for="ta">TA</label>
            <input type="checkbox" id="ta" value="6" v-model="appointment.mediumArray" @keypress.self.prevent.13>
            <label for="other">その他</label>
            <input type="checkbox" id="other" value="7" v-model="appointment.mediumArray" @keypress.self.prevent.13>
            <label for="ikkatu">一括資料請求</label>
            <input type="checkbox" id="ikkatu" value="8" v-model="appointment.mediumArray" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2">AP種類</th>
        <td colspan="4"><multiselect v-model="watch.ap_type" :options="ap_type" label="name" :searchable="false" :show-labels="false" placeholder="AP種類"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">HP閲覧</th>
        <td colspan="4"><multiselect v-model="watch.hp_browse" :options="hp_browse" label="name" :searchable="false" :show-labels="false" placeholder="HP閲覧"></multiselect></td>
        <th colspan="2">HP種類</th>
        <td colspan="4"><multiselect v-model="watch.hp_type" :options="hp_type" label="name" :searchable="false" :show-labels="false" placeholder="HP種類"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2" class="req">取得日</th>
        <td colspan="4"><input type="text" required maxlength="10" minlength="10" v-model="appointment.acquisition_date" placeholder="取得日" @keypress.self.prevent.13></td>
        <th colspan="2" class="req">問合せ結果</th>
        <td colspan="4"><multiselect v-model="watch.support" :options="support" label="name" :searchable="false" :show-labels="false" placeholder="問合せ結果"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">問合せ結果詳細</th>
        <td colspan="4"><multiselect v-model="watch.missing_detail" :options="missing_detail" label="name" :searchable="false" :show-labels="false" placeholder="問合せ結果詳細"></multiselect></td>
        <th colspan="2">今後連絡できるか</th>
        <td colspan="4"><multiselect v-model="watch.contact_later" :options="contact_later" label="name" :searchable="false" :show-labels="false" placeholder="今後連絡できるか"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">次回連絡予定日</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="appointment.next_contact_date" placeholder="次回連絡予定日" @keypress.self.prevent.13></td>
        <th colspan="2">次回連絡手段</th>
        <td colspan="4"><multiselect v-model="watch.next_contact_method" :options="next_contact_method" label="name" :searchable="false" :show-labels="false" placeholder="次回連絡手段"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">AP応対者</th>
        <td colspan="4"><input type='text' v-model="appointment.person" placeholder="AP応対者" @keypress.self.prevent.13></td>
        <th colspan="2">営業結果</th>
        <td colspan="4"><multiselect v-model="watch.result" :options="result" label="name" :searchable="false" :show-labels="false" placeholder="営業結果"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">性別</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="gender_0">未選択</label>
            <input type="radio" id="gender_0" value="0" v-model="appointment.gender" @keypress.self.prevent.13>
            <label for="gender_1">男</label>
            <input type="radio" id="gender_1" value="1" v-model="appointment.gender" @keypress.self.prevent.13>
            <label for="gender_2">女</label>
            <input type="radio" id="gender_2" value="2" v-model="appointment.gender" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2">サブ性別</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="sub_gender_0">未選択</label>
            <input type="radio" id="sub_gender_0" value="0" v-model="appointment.sub_gender" @keypress.self.prevent.13>
            <label for="sub_gender_1">男</label>
            <input type="radio" id="sub_gender_1" value="1" v-model="appointment.sub_gender" @keypress.self.prevent.13>
            <label for="sub_gender_2">女</label>
            <input type="radio" id="sub_gender_2" value="2" v-model="appointment.sub_gender" @keypress.self.prevent.13>
          </div>
        </td>
      </tr>
      <tr>
        <th colspan="2">公/国/私</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="school_type_0">未選択</label>
            <input type="radio" id="school_type_0" value="0" v-model="appointment.school_type" @keypress.self.prevent.13>
            <label for="school_type_1">公立</label>
            <input type="radio" id="school_type_1" value="1" v-model="appointment.school_type" @keypress.self.prevent.13>
            <label for="school_type_2">国立</label>
            <input type="radio" id="school_type_2" value="2" v-model="appointment.school_type" @keypress.self.prevent.13>
            <label for="school_type_3">私立</label>
            <input type="radio" id="school_type_3" value="3" v-model="appointment.school_type" @keypress.self.prevent.13>
            <label for="school_type_4">その他</label>
            <input type="radio" id="school_type_4" value="4" v-model="appointment.school_type" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2">サブ公/国/私</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="sub_school_type_0">未選択</label>
            <input type="radio" id="sub_school_type_0" value="0" v-model="appointment.sub_school_type" @keypress.self.prevent.13>
            <label for="sub_school_type_1">公立</label>
            <input type="radio" id="sub_school_type_1" value="1" v-model="appointment.sub_school_type" @keypress.self.prevent.13>
            <label for="sub_school_type_2">国立</label>
            <input type="radio" id="sub_school_type_2" value="2" v-model="appointment.sub_school_type" @keypress.self.prevent.13>
            <label for="sub_school_type_3">私立</label>
            <input type="radio" id="sub_school_type_3" value="3" v-model="appointment.sub_school_type" @keypress.self.prevent.13>
            <label for="sub_school_type_4">その他</label>
            <input type="radio" id="sub_school_type_4" value="4" v-model="appointment.sub_school_type" @keypress.self.prevent.13>
          </div>
        </td>
      </tr>
      <tr>
        <th colspan="2">学校名</th>
        <td colspan="4"><input type='text' v-model="appointment.school_name" placeholder="学校名" @keypress.self.prevent.13></td>
        <th colspan="2">サブ学校名</th>
        <td colspan="4"><input type='text' v-model="appointment.sub_school_name" placeholder="サブ学校名" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">小/中/高/幼</th>
        <td colspan="4"><multiselect v-model="watch.school_stage" :options="school_stage" label="name" :searchable="false" :show-labels="false" placeholder="小/中/高/幼"></multiselect></td>
        <th colspan="2">サブ小/中/高/幼</th>
        <td colspan="4"><multiselect v-model="watch.sub_school_stage" :options="school_stage" label="name" :searchable="false" :show-labels="false" placeholder="サブ小/中/高/幼"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">学年</th>
        <td colspan="4"><multiselect v-model="watch.grade" :options="grade" label="name" :searchable="false" :show-labels="false" placeholder="学年"></multiselect></td>
        <th colspan="2">サブ学年</th>
        <td colspan="4"><multiselect v-model="watch.sub_grade" :options="grade" label="name" :searchable="false" :show-labels="false" placeholder="サブ学年"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">APメモ</th>
        <td colspan="4"><input type='text' v-model="appointment.memo" placeholder="APメモ" @keypress.self.prevent.13></td>
        <th colspan="2">DM届いた月</th>
        <td colspan="4"><input type="text" maxlength="7" minlength="7" v-model="appointment.dm" :searchable="false" :show-labels="false" placeholder="DM届いた月" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">DM情報</th>
        <td colspan="4"><multiselect v-model="watch.dm_information" :options="dm_information" label="name" :searchable="false" :show-labels="false" placeholder="DM情報"></multiselect></td>
        <th colspan="2"></th>
        <td colspan="4"></td>
      </tr>
      <tr>
        <th colspan="2">店種類</th>
        <td colspan="4"><multiselect v-model="watch.shop_type" :options="shop_type" label="name" :searchable="false" :show-labels="false" placeholder="店種類"></multiselect></td>
        <th colspan="2">店名</th>
        <td colspan="4"><input type='text' v-model="appointment.shop_name" placeholder="店名" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">訪問日</th>
        <td colspan="4"><input type="text" required maxlength="10" minlength="10" v-model="appointment.visit_date" placeholder="訪問日" @keypress.self.prevent.13></td>
        <th colspan="2">訪問時間</th>
        <td colspan="4"><input type='text' v-model="appointment.visit_time" placeholder="訪問時間" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">希望曜日</th>
        <td colspan="4"><input type="text" v-model="appointment.request_of_day_of_week" placeholder="希望曜日" @keypress.self.prevent.13></td>
        <th colspan="2">希望曜日備考</th>
        <td colspan="4"><input type='text' v-model="appointment.request_of_day_of_week_note" placeholder="希望曜日備考" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">駐車場</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="parking_0">未選択</label>
            <input type="radio" id="parking_0" value="0" v-model="appointment.parking" @keypress.self.prevent.13>
            <label for="parking_1">有</label>
            <input type="radio" id="parking_1" value="1" v-model="appointment.parking" @keypress.self.prevent.13>
            <label for="parking_2">無</label>
            <input type="radio" id="parking_2" value="2" v-model="appointment.parking" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2">駐車場備考</th>
        <td colspan="4"><input type="text" v-model="appointment.parking_note" placeholder="駐車場備考" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">メイン成績</th>
        <td colspan="4"><input type="text" v-model="appointment.achievement" placeholder="メイン成績" @keypress.self.prevent.13></td>
        <th colspan="2">メイン習い事</th>
        <td colspan="4"><input type="text" v-model="appointment.learning" placeholder="メイン習い事" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">メイン習い事いつから</th>
        <td colspan="4"><input type="text" v-model="appointment.learning_start_period" placeholder="メイン習い事いつから" @keypress.self.prevent.13></td>
        <th colspan="2">メイン習い事きっかけ</th>
        <td colspan="4"><input type="text" v-model="appointment.learning_nervous" placeholder="メイン習い事きっかけ" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">メイン習い事成果</th>
        <td colspan="4"><multiselect v-model="watch.learning_result" :options="learning_result" label="name" :searchable="false" :show-labels="false" placeholder="メイン習い事成果"></multiselect></td>
        <th colspan="2">メイン習い事継続</th>
        <td colspan="4"><multiselect v-model="watch.learning_continuation" :options="learning_continuation" label="name" :searchable="false" :show-labels="false" placeholder="メイン習い事継続"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">サブ成績</th>
        <td colspan="4"><input type="text" v-model="appointment.sub_achievement" placeholder="サブ成績" @keypress.self.prevent.13></td>
        <th colspan="2">サブ習い事</th>
        <td colspan="4"><input type="text" v-model="appointment.sub_learning" placeholder="サブ習い事" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">サブ習い事いつから</th>
        <td colspan="4"><input type="text" v-model="appointment.sub_learning_start_period" placeholder="サブ習い事いつから" @keypress.self.prevent.13></td>
        <th colspan="2">サブ習い事きっかけ</th>
        <td colspan="4"><input type="text" v-model="appointment.sub_learning_nervous" placeholder="サブ習い事きっかけ" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">サブ習い事成果</th>
        <td colspan="4"><multiselect v-model="watch.sub_learning_result" :options="learning_result" label="name" :searchable="false" :show-labels="false" placeholder="サブ習い事成果"></multiselect></td>
        <th colspan="2">サブ習い事継続</th>
        <td colspan="4"><multiselect v-model="watch.sub_learning_continuation" :options="learning_continuation" label="name" :searchable="false" :show-labels="false" placeholder="サブ習い事継続"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">話した相手</th>
        <td colspan="4"><multiselect v-model="watch.contact_person" :options="contact_person" label="name" :searchable="false" :show-labels="false" placeholder="話した相手"></multiselect></td>
        <th colspan="2">当日の同席者</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="a">母</label>
            <input type="checkbox" id="a" value="母" v-model="appointment.attendedArray" @keypress.self.prevent.13>
            <label for="b">父</label>
            <input type="checkbox" id="b" value="父" v-model="appointment.attendedArray" @keypress.self.prevent.13>
            <label for="c">祖母</label>
            <input type="checkbox" id="c" value="祖母" v-model="appointment.attendedArray" @keypress.self.prevent.13>
            <label for="d">祖父</label>
            <input type="checkbox" id="d" value="祖父" v-model="appointment.attendedArray" @keypress.self.prevent.13>
            <label for="oba">伯母</label>
            <input type="checkbox" id="oba" value="伯母" v-model="appointment.attendedArray" @keypress.self.prevent.13>
            <label for="oji">伯父</label>
            <input type="checkbox" id="oji" value="伯父" v-model="appointment.attendedArray" @keypress.self.prevent.13>
          </div>
        </td>
      </tr>
      <tr>
        <th colspan="2">父親の絡み</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="fathers_involvement_0">未選択</label>
            <input type="radio" id="fathers_involvement_0" value="0" v-model="appointment.fathers_involvement" @keypress.self.prevent.13>
            <label for="fathers_involvement_1">有</label>
            <input type="radio" id="fathers_involvement_1" value="1" v-model="appointment.fathers_involvement" @keypress.self.prevent.13>
            <label for="fathers_involvement_2">無</label>
            <input type="radio" id="fathers_involvement_2" value="2" v-model="appointment.fathers_involvement" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2">特記事項</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="e">母子・父子家庭</label>
            <input type="checkbox" id="e" value="母子・父子家庭" v-model="appointment.noticesArray" @keypress.self.prevent.13>
            <label for="f">バッティング</label>
            <input type="checkbox" id="f" value="バッティング" v-model="appointment.noticesArray" @keypress.self.prevent.13>
            <label for="g">不登校</label>
            <input type="checkbox" id="g" value="不登校" v-model="appointment.noticesArray" @keypress.self.prevent.13>
            <label for="h">障害</label>
            <input type="checkbox" id="h" value="障害" v-model="appointment.noticesArray" @keypress.self.prevent.13>
          </div>
        </td>
      </tr>
      <tr>
        <th colspan="2">送るもの</th>
        <td colspan="4" class="checkbox">
          <div>
            <label for="n">体験案内</label>
            <input type="checkbox" id="n" value="体験案内" v-model="appointment.sending_productsArray" @keypress.self.prevent.13>
            <label for="o">資料</label>
            <input type="checkbox" id="o" value="資料" v-model="appointment.sending_productsArray" @keypress.self.prevent.13>
            <label for="p">料金表</label>
            <input type="checkbox" id="p" value="料金表" v-model="appointment.sending_productsArray" @keypress.self.prevent.13>
            <label for="q">Quoカード</label>
            <input type="checkbox" id="q" value="Quoカード" v-model="appointment.sending_productsArray" @keypress.self.prevent.13>
            <label for="r">ギフトカード</label>
            <input type="checkbox" id="r" value="ギフトカード" v-model="appointment.sending_productsArray" @keypress.self.prevent.13>
            <label for="s">キャンペーンチラシ</label>
            <input type="checkbox" id="s" value="キャンペーンチラシ" v-model="appointment.sending_productsArray" @keypress.self.prevent.13>
            <label for="t">送らない</label>
            <input type="checkbox" id="t" value="送らない" v-model="appointment.sending_productsArray" @keypress.self.prevent.13>
          </div>
        </td>
        <th colspan="2">送る方法</th>
        <td colspan="4"><multiselect v-model="watch.sending_method" :options="sending_method" label="name" :searchable="false" :show-labels="false" placeholder="送る方法"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2" class="req">郵送・FAX / 予定日</th>
        <td colspan="4"><input type="text" required maxlength="10" minlength="10" v-model="appointment.sending_date" placeholder="郵送・FAX / 予定日" @keypress.self.prevent.13></td>
        <th colspan="2">送信時間</th>
        <td colspan="4"><input type="text" v-model="appointment.sending_time" placeholder="送信時間" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">確認項目</th>
        <td colspan="10" class="checkbox">
          <div>
            <label for="i">会社名</label>
            <input type="checkbox" id="i" v-model="watch.transmission_item_company" @keypress.self.prevent.13>
            <label for="j">2通りの教え方</label>
            <input type="checkbox" id="j" v-model="watch.transmission_item_course" @keypress.self.prevent.13>
            <label for="k">体験はADが訪問</label>
            <input type="checkbox" id="k" v-model="watch.transmission_item_visitor" @keypress.self.prevent.13>
            <label for="l">勧誘する目的</label>
            <input type="checkbox" id="l" v-model="watch.transmission_item_purpose" @keypress.self.prevent.13>
            <label for="m">体験は2時間</label>
            <input type="checkbox" id="m" v-model="watch.transmission_item_requiredtime" @keypress.self.prevent.13>
          </div>
        </td>
      </tr>
      <tr>
        <th colspan="2">備考</th>
        <td colspan="10"><textarea v-model="appointment.note" placeholder="備考"></textarea></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
let jsonp = require('jsonp')
export default {
  props: {
    appointment: Object,
    watch: Object
  },
  data () {
    return {
    }
  },
  computed: {
    state () {
      return this.$store.getters['appointments/state']
    },

    preferred_contact () {
      return this.$store.getters['appointments/preferred_contact']
    },

    school_stage () {
      return this.$store.getters['appointments/school_stage']
    },

    grade () {
      return this.$store.getters['appointments/grade']
    },

    dm_information () {
      return this.$store.getters['appointments/dm_information']
    },

    support () {
      return this.$store.getters['appointments/support']
    },

    missing_detail () {
      return this.$store.getters['appointments/missing_detail']
    },

    contact_later () {
      return this.$store.getters['appointments/contact_later']
    },

    result () {
      return this.$store.getters['appointments/result']
    },

    ap_type () {
      return this.$store.getters['appointments/ap_type']
    },

    shop_type () {
      return this.$store.getters['appointments/shop_type']
    },

    hp_type () {
      return this.$store.getters['appointments/hp_type']
    },

    hp_browse () {
      return this.$store.getters['appointments/hp_browse']
    },

    next_contact_method () {
      return this.$store.getters['appointments/next_contact_method']
    },

    contact_person () {
      return this.$store.getters['appointments/contact_person']
    },

    learning_result () {
      return this.$store.getters['appointments/learning_result']
    },

    learning_continuation () {
      return this.$store.getters['appointments/learning_continuation']
    },

    sending_method () {
      return this.$store.getters['appointments/sending_method']
    },

    prefs () {
      return this.$store.getters.prefs.reverse()
    }
  },
  directives: {
    focus: {
      inserted (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },
  methods: {
    toggle () {
      this.$refs.multiselect.$el.focus()
    },

    select (selectedOption, id) {
      console.log(selectedOption)
    },

    getYubin (e) {
      let that = this
      // console.log(e)
      const value = e.target.value
      if (value.length > 5 && that.appointment.address1 === '') {
        jsonp('http://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value, null, function (err, data) {
          if (err) {
            // error
            console.error(err.message)
          } else {
            // success
            console.log(data)
            if (data.results[0].address1 === '北海道') {
              that.watch.pref = { name: '1. 北海道', id: 1 }
            } else if (data.results[0].address1 === '青森県') {
              that.watch.pref = { name: '2. 青森県', id: 2 }
            } else if (data.results[0].address1 === '秋田県') {
              that.watch.pref = { name: '3. 秋田県', id: 3 }
            } else if (data.results[0].address1 === '岩手県') {
              that.watch.pref = { name: '4. 岩手県', id: 4 }
            } else if (data.results[0].address1 === '山形県') {
              that.watch.pref = { name: '5. 山形県', id: 5 }
            } else if (data.results[0].address1 === '宮城県') {
              that.watch.pref = { name: '6. 宮城県', id: 6 }
            } else if (data.results[0].address1 === '福島県') {
              that.watch.pref = { name: '7. 福島県', id: 7 }
            } else if (data.results[0].address1 === '栃木県') {
              that.watch.pref = { name: '8. 栃木県', id: 8 }
            } else if (data.results[0].address1 === '山梨県') {
              that.watch.pref = { name: '9. 山梨県', id: 9 }
            } else if (data.results[0].address1 === '群馬県') {
              that.watch.pref = { name: '10. 群馬県', id: 10 }
            } else if (data.results[0].address1 === '茨城県') {
              that.watch.pref = { name: '11. 茨城県', id: 11 }
            } else if (data.results[0].address1 === '千葉県') {
              that.watch.pref = { name: '12. 千葉県', id: 12 }
            } else if (data.results[0].address1 === '埼玉県') {
              that.watch.pref = { name: '13. 埼玉県', id: 13 }
            } else if (data.results[0].address1 === '東京都') {
              that.watch.pref = { name: '14. 東京都', id: 14 }
            } else if (data.results[0].address1 === '神奈川県') {
              that.watch.pref = { name: '15. 神奈川県', id: 15 }
            } else if (data.results[0].address1 === '静岡県') {
              that.watch.pref = { name: '16. 静岡県', id: 16 }
            } else if (data.results[0].address1 === '長野県') {
              that.watch.pref = { name: '17. 長野県', id: 17 }
            } else if (data.results[0].address1 === '愛知県') {
              that.watch.pref = { name: '18. 愛知県', id: 18 }
            } else if (data.results[0].address1 === '岐阜県') {
              that.watch.pref = { name: '19. 岐阜県', id: 19 }
            } else if (data.results[0].address1 === '新潟県') {
              that.watch.pref = { name: '20. 新潟県', id: 20 }
            } else if (data.results[0].address1 === '富山県') {
              that.watch.pref = { name: '21. 富山県', id: 21 }
            } else if (data.results[0].address1 === '石川県') {
              that.watch.pref = { name: '22. 石川県', id: 22 }
            } else if (data.results[0].address1 === '福井県') {
              that.watch.pref = { name: '23. 福井県', id: 23 }
            } else if (data.results[0].address1 === '滋賀県') {
              that.watch.pref = { name: '24. 滋賀県', id: 24 }
            } else if (data.results[0].address1 === '京都府') {
              that.watch.pref = { name: '25. 京都府', id: 25 }
            } else if (data.results[0].address1 === '三重県') {
              that.watch.pref = { name: '26. 三重県', id: 26 }
            } else if (data.results[0].address1 === '和歌山県') {
              that.watch.pref = { name: '27. 和歌山県', id: 27 }
            } else if (data.results[0].address1 === '奈良県') {
              that.watch.pref = { name: '28. 奈良県', id: 28 }
            } else if (data.results[0].address1 === '大阪府') {
              that.watch.pref = { name: '29. 大阪府', id: 29 }
            } else if (data.results[0].address1 === '兵庫県') {
              that.watch.pref = { name: '30. 兵庫県', id: 30 }
            } else if (data.results[0].address1 === '鳥取県') {
              that.watch.pref = { name: '31. 鳥取県', id: 31 }
            } else if (data.results[0].address1 === '島根県') {
              that.watch.pref = { name: '32. 島根県', id: 32 }
            } else if (data.results[0].address1 === '岡山県') {
              that.watch.pref = { name: '33. 岡山県', id: 33 }
            } else if (data.results[0].address1 === '広島県') {
              that.watch.pref = { name: '34. 広島県', id: 34 }
            } else if (data.results[0].address1 === '山口県') {
              that.watch.pref = { name: '35. 山口県', id: 35 }
            } else if (data.results[0].address1 === '高知県') {
              that.watch.pref = { name: '36. 高知県', id: 36 }
            } else if (data.results[0].address1 === '徳島県') {
              that.watch.pref = { name: '37. 徳島県', id: 37 }
            } else if (data.results[0].address1 === '香川県') {
              that.watch.pref = { name: '38. 香川県', id: 38 }
            } else if (data.results[0].address1 === '愛媛県') {
              that.watch.pref = { name: '39. 愛媛県', id: 39 }
            } else if (data.results[0].address1 === '福岡県') {
              that.watch.pref = { name: '40. 福岡県', id: 40 }
            } else if (data.results[0].address1 === '佐賀県') {
              that.watch.pref = { name: '41. 佐賀県', id: 41 }
            } else if (data.results[0].address1 === '長崎県') {
              that.watch.pref = { name: '42. 長崎県', id: 42 }
            } else if (data.results[0].address1 === '熊本県') {
              that.watch.pref = { name: '43. 熊本県', id: 43 }
            } else if (data.results[0].address1 === '宮崎県') {
              that.watch.pref = { name: '44. 宮崎県', id: 44 }
            } else if (data.results[0].address1 === '大分県') {
              that.watch.pref = { name: '45. 大分県', id: 45 }
            } else if (data.results[0].address1 === '鹿児島県') {
              that.watch.pref = { name: '46. 鹿児島県', id: 46 }
            } else if (data.results[0].address1 === '沖縄県') {
              that.watch.pref = { name: '47. 沖縄県', id: 47 }
            }
            that.appointment.address1 = data.results[0].address2 + data.results[0].address3
          }
        })
      }
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss' scoped>
.req {
  /* background: #dffbef; */
  background: #41b883;
}
table {
  border-spacing: 0;
  width: 100%;
  border-top: solid 1px #ddd;
  tr {
    th {
      background: #37474f;
      color: #fbfbfb;
      padding: .5rem;
      font-weight: normal;
      font-size: .85rem;
      .fa {
        margin-left: 10px;
        position: relative;
        font-size: 12px;
        &:hover > .help {
          opacity: 1;
        }
        .help {
          position: absolute;
          top: -5px;
          left: 20px;
          width: 200px;
          height: 50px;
          border: solid 1px #039be5;
          background: #039be5;
          color: #fff;
          padding: 3px;
          opacity: 0;
          z-index: 2;
          transition: all .5s;
          &:before {
            content: '';
            position: absolute;
            border-right: solid 5px #039be5;
            border-left: solid 5px rgba(255, 255, 255, 0);
            border-top: solid 5px rgba(255, 255, 255, 0);
            border-bottom: solid 5px rgba(255, 255, 255, 0);
            font-size: 0;
            margin: 2px 0 0 -14px;
          }
        }
      }
    }
    td {
      border-bottom: solid 1px #ddd;
      border-right: solid 1px #ddd;
      input, textarea {
        outline: 0;
        border: none;
        width: 100%;
        padding: .5rem;
        font-size: .85rem;
        &:focus {
          background: #cdeeff;
        }
      }
      textarea {
        height: 150px;
        &:focus {
          background: #cdeeff;
        }
      }
    }
  }
}
.checkbox {
  font-size: .85rem;
  color: #333;
  div {
    display: flex;
    label {
      padding-top: 9px;
      padding-left: 5px;
    }
    input {
      height: 29px;
      width: 20px;
    }
  }
}
</style>
<style lang="scss">
.AppointmentForm {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    font-size: .85rem;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: .85rem;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding: .5rem 3px;
    margin: 0;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// AppointmentForm.vue?55064276